<template>
  <el-dialog
      title="线路信息"
      width="610px"
      destroy-on-close
      :visible.sync="showDialog"
      :before-close="handleClose"
      append-to-body
      >
    <div>
      <el-form :model="form" :rules="rules" ref="form" label-width="96px">
        <el-row>
          <el-form-item label="机构名称" prop="organizationId">
          <el-select v-model="form.organizationId" filterable :disabled="!!form.id"
            v-if="mixinUserInfo && mixinUserInfo.organizationType === 1">
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{
            organizations && organizations[0] && organizations[0].name
          }}</span>
        </el-form-item>
          <el-form-item label="起讫地" required style="margin-bottom: 0">
            <el-col :span="11">
              <el-form-item prop="routeNameStart">
                <el-input oninput="value=value.replace(/[\s-]/g,'')" type="text"
                          placeholder="起始地(同班线经营信息表一致)" maxlength="20"
                          v-model="form.routeNameStart"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: center">-</el-col>
            <el-col :span="11">
              <el-form-item prop="routeNameEnd">
                <el-input oninput="value=value.replace(/[\s-]/g,'')" type="text"
                          placeholder="目的地(同班线经营信息表一致)" maxlength="20"
                          v-model="form.routeNameEnd"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">

            </el-col>

          </el-form-item>

        </el-row>


        <el-form-item label="线路类别" prop="routeType">
          <el-select v-model="form.routeType" filterable placeholder="请选择线路类别">
            <el-option label="一类" value="1"></el-option>
            <el-option label="二类" value="2"></el-option>
            <el-option label="三类" value="3"></el-option>
            <el-option label="四类" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="公里数" prop="km">
          <el-input v-input-filter="{ min: 1, max: 9999, precision: 0 }" style="width: 100%" type="text"
                    placeholder="请输入公里数" maxlength="30"
                    v-model="form.km"></el-input>
        </el-form-item>
        <el-form-item label="接送模式" prop="transferMode">
          <el-select v-model="form.transferMode" filterable placeholder="请选择接送模式">
            <el-option label="上门接送" value="1"></el-option>
            <el-option label="定点接送" value="2"></el-option>
            <el-option label="短途驳载" value="3"></el-option>
            <el-option label="其它" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="开通日期" prop="openDate">
          <el-date-picker
              style="width: 100%"
              v-model="form.openDate"
              type="date"
              value-format="timestamp"
              placeholder="请选择开通日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="开通线路" prop="lineId">
          <el-select
            v-model="form.lineId"
            multiple
            filterable
            placeholder="请选择开通线路"
            style="width: 100%">
            <el-option
              v-for="item in allLineList"
              :key="item.id"
              :label="item.stationName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


      </el-form>


    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onsubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import upload_pdfs from "@/components/pdf/upload_pdfs";

export default {
  name: "supervise",
  components: {
    upload_pdfs
  },
  data() {
    return {
      showDialog: false,
      form: {
        routeNameStart: "",
        routeNameEnd: "",
        routeType: "",
        km: "",
        transferMode: "",
        openDate: "",
        lineId: []
      },
      rules: {
        organizationId: [{required: true, message: '请选择机构名称', trigger: ['blur', 'change']}],
        routeNameStart: [{
          required: true,
          message: '请输入起始地',
          trigger: ['blur', 'change']
        }],
        routeNameEnd: [{
          required: true,
          message: '请输入目的地',
          trigger: ['blur', 'change']
        }],
        routeType: [{required: true, message: '请选择线路类别', trigger: ['blur', 'change']}],
        km: [{required: true, message: '请输入公里数', trigger: ['blur', 'change']}],
        transferMode: [{required: true, message: '请选择接送模式', trigger: ['blur', 'change']}],
        openDate: [{required: true, message: '请选择开通日期', trigger: ['blur', 'change']}],
        lineId: [{required: true, message: '请选择开通线路', trigger: ['blur', 'change']}]
      },
      allLineList: [],
    }
  },
  props: {
    value: {
      default: false
    },
    lineData: {
      default: () => ({})
    },
    
  },
  watch: {
    async value() {
      this.showDialog = this.value
      if(this.showDialog) {
        this.getInitMerchantFn()
        await this.mixinOrganizations();
      if (this.mixinUserInfo && this.mixinUserInfo.organizationType === 2) {
        if (
          this.organizations &&
          this.organizations[0] &&
          this.organizations[0].id
        ) {
          this.$set(this.form, "organizationId", this.organizations[0].id);
        }
      }
      }
    },
    'form.organizationId': {
      handler(val) {
        this.getAllLine(val)
      },
      immediate: true
    }
  },
  methods: {
    async getAllLine(organizationId) {
            let line = await this.mixinGetLines({
                organizationId: organizationId
            })
            this.allLineList = line.map(item => ({
              ...item,
              label: item.startStationName + "-" + item.endStationName,
              value: item.id,
              stationName: item.startStationName + "-" + item.endStationName,
            }))
        },
    async getInitMerchantFn() {
      this.form = {
          ...this.form,
          ...this.lineData,
          openDate:this.lineData.openDate ? new Date(this.lineData.openDate).getTime() : '',
          routeNameStart: this.lineData.routeName ? this.lineData.routeName.split('-')[0] : '',
          routeNameEnd: this.lineData.routeName ? this.lineData.routeName.split('-')[1] : '',
          lineId: this.lineData.lineId ? this.lineData.lineId.split(',').map(Number) : []
        }
    },

    handleClose() {
      this.form = {
        routeName: "",
        routeType: "",
        km: "",
        transferMode: "",
        openDate: "",
        lineId: []
      }
      this.$emit('input', false)
      this.$emit('close', false)
    },
    onsubmit() {
      console.log('this.form.lineId',this.form.lineId)
      console.log('this.allLineList',this.allLineList)
        if(this.allLineList.length < this.form.lineId.length || this.form.lineId.some(pitem => !this.allLineList.find(item => item.id == pitem))) {
            this.$message.warning('选择的线路与机构名称不匹配')
            return false
          }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const url = '/api/v1/manage/line/survey'
          const params = {
            ...this.form,
            lineId: this.form.lineId.join(','),
            openDate: this.form.openDate ? this.$utils.timeFn(this.form.openDate, 'YYYY-MM-DD') : '',
            routeName: [this.form.routeNameStart, this.form.routeNameEnd].join('-')
          }
          const {code} = await this.$axios.post(url, params)
          if (code === 1) {
            this.$message.success('操作成功')
            this.handleClose()
            this.$emit('success')
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    }
  }
}
</script>
